var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3a2 2 0 012-2h5.963l2.053 1.76 1.286 1.101A2 2 0 0114 5.38V13a2 2 0 01-2 2H4a2 2 0 01-2-2V3z",
    stroke: "#2C2D2E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85 9.076a1 1 0 101.3-1.518L8 5 4.85 7.558a1 1 0 101.3 1.518L7 8.491h2l.85.585z",
    fill: "#2C2D2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7h2v5a1 1 0 11-2 0V7z",
    fill: "#2C2D2E"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yIDNDMiAxLjg5NTQzIDIuODk1NDMgMSA0IDFIOS45NjM0MUwxMi4wMTU5IDIuNzU5MjZMMTMuMzAxNiAzLjg2MTI5QzEzLjc0NDkgNC4yNDEyNiAxNCA0Ljc5NTk2IDE0IDUuMzc5OFYxM0MxNCAxNC4xMDQ2IDEzLjEwNDYgMTUgMTIgMTVINEMyLjg5NTQzIDE1IDIgMTQuMTA0NiAyIDEzVjNaIiBzdHJva2U9IiMyQzJEMkUiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggZD0iTTkuODQ5MTkgOS4wNzYzM0MxMC4yNjg1IDkuNDM1NzUgMTAuODk5OCA5LjM4NzE5IDExLjI1OTIgOC45Njc4N0MxMS42MTg3IDguNTQ4NTQgMTEuNTcwMSA3LjkxNzI0IDExLjE1MDggNy41NTc4Mkw3Ljk5OTk4IDVMNC44NDkxOSA3LjU1NzgyQzQuNDI5ODYgNy45MTcyNCA0LjM4MTMgOC41NDg1NCA0Ljc0MDczIDguOTY3ODdDNS4xMDAxNSA5LjM4NzE5IDUuNzMxNDUgOS40MzU3NSA2LjE1MDc3IDkuMDc2MzNMNi45OTk5OCA4LjQ5MTNMOC45OTk5OCA4LjQ5MTNMOS44NDkxOSA5LjA3NjMzWiIgZmlsbD0iIzJDMkQyRSIvPgogICAgPHBhdGggZD0iTTcgN0g5VjEyQzkgMTIuNTUyMyA4LjU1MjI4IDEzIDggMTNDNy40NDc3MiAxMyA3IDEyLjU1MjMgNyAxMlY3WiIgZmlsbD0iIzJDMkQyRSIvPgo8L3N2Zz4K";
export { SvgUploadFile as ReactComponent };